function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".messaging_svg__i{fill:none}.messaging_svg__d{stroke:#1d1f2c;stroke-width:2px}.messaging_svg__d,.messaging_svg__e{fill:#fff;stroke-linecap:round;stroke-linejoin:round}.messaging_svg__f{fill:#1d1f2c}.messaging_svg__g{fill:#d32f2f}.messaging_svg__h{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.739 68.596a22.994 22.994 0 010-32.525L35.313 8.497A23 23 0 1167.84 41.022L40.264 68.596a22.994 22.994 0 01-32.525 0z",
  fill: "#ffd5d5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.001 9h23a1 1 0 011 1v45a1 1 0 01-1 1H46.548L27.001 44v4a1 1 0 01-1 1h-7a1 1 0 01-1-1V10a1 1 0 011-1z",
  stroke: "#1d1f2c",
  strokeWidth: 2,
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "messaging_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__h",
  d: "M33.001 11.76h-5v-5h5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__i",
  d: "M34.001 12.76h-7v-7h7z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "messaging_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__h",
  d: "M64.501 26h-5v-5h5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__i",
  d: "M65.501 27h-7v-7h7z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "messaging_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__h",
  d: "M47.001 11.76h-5v-5h5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__i",
  d: "M48.001 12.76h-7v-7h7z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  className: "messaging_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__h",
  d: "M10.35 61.806V55.915v-.088c-.002-.037-.002-.076-.002-.113v-.33c0-.973-.001-1.635-.003-1.807a.166.166 0 00-.166-.135H6.854c-.8 0-1.453-.65-1.453-1.449V22.024c0-.8.653-1.453 1.453-1.453h45.28c.8 0 1.453.653 1.453 1.453v31.418h-1c-28.2 0-33.395.004-33.836.006a.175.175 0 00-.094.051l-6.6 6.6-1.707 1.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.35 59.392l6.606-6.606c.213-.207.476-.322.748-.338.025-.006 27.45-.006 33.883-.006V22.024a.451.451 0 00-.453-.453H6.854a.451.451 0 00-.453.453v29.97c0 .247.201.448.453.448h3.325c.615 0 1.115.471 1.166 1.069.002.011.003.842.003 1.873v.33l.002.201V59.392m0 2a1.998 1.998 0 01-2-2v-3.477-.072c-.002-.043-.002-.086-.002-.13v-.329-.942H6.854a2.454 2.454 0 01-2.453-2.449V22.024c0-1.353 1.1-2.453 2.453-2.453h45.28c1.353 0 2.453 1.1 2.453 2.453v30.418c0 1.106-.895 2-2 2-24.99 0-31.9.002-33.463.004l-6.36 6.36a2 2 0 01-1.414.586z",
  fill: "#1d1f2c"
})), /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__f",
  d: "M45.145 35.967h-32.3a1.17 1.17 0 100 2.341h32.3a1.17 1.17 0 100-2.341zM45.145 27.967h-32.3a1.17 1.17 0 100 2.341h32.3a1.17 1.17 0 100-2.341zM23.927 43.705H12.843a1.17 1.17 0 100 2.341h11.084a1.17 1.17 0 100-2.341z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  className: "messaging_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__h",
  d: "M67.733 71.423l-1.706-1.706-4.242-4.243a1.275 1.275 0 01-.012-.011l-.006-.005-.002-.002a.165.165 0 00-.112-.043h-23.07a1.455 1.455 0 01-1.453-1.453V44.34c0-.801.652-1.453 1.453-1.453H69.88c.8 0 1.453.652 1.453 1.453V63.96c0 .801-.652 1.453-1.453 1.453h-1.975a.17.17 0 00-.166.14c-.002.303-.004 2.193-.005 3.458l-.001 2.412z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.734 69.01s.002-3.491.005-3.517a1.17 1.17 0 011.166-1.08h1.975c.25 0 .453-.203.453-.453V44.34a.453.453 0 00-.453-.453H38.583a.453.453 0 00-.453.453V63.96c0 .25.203.453.453.453h23.07a1.165 1.165 0 01.818.334l.014.013 4.25 4.25m0 2a2 2 0 01-1.415-.586l-4.01-4.01H38.582a2.456 2.456 0 01-2.453-2.454V44.34c0-1.353 1.1-2.453 2.453-2.453H69.88c1.352 0 2.453 1.1 2.453 2.453V63.96c0 1.353-1.1 2.453-2.453 2.453h-1.143l-.003 2.598a2 2 0 01-2 2z",
  fill: "#d32f2f"
})), /*#__PURE__*/React.createElement("path", {
  className: "messaging_svg__g",
  d: "M54.149 51.979a1.865 1.865 0 101.864 1.865 1.865 1.865 0 00-1.864-1.865zM45.486 51.979a1.865 1.865 0 101.864 1.865 1.865 1.865 0 00-1.864-1.865zM62.81 51.979a1.865 1.865 0 101.864 1.865 1.865 1.865 0 00-1.864-1.865z"
}));

var SvgMessaging = function SvgMessaging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/messaging.1d8780ce.svg";
export { SvgMessaging as ReactComponent };